import React from "react";
import { Container } from "native-base";

const ContainerCards = ({
  width = "386px",
  height = "108px",
  boxShadow = "0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)",
  border = "none",
  background = "none",
  borderRadius = "8px",
  maxW = "100%",
  ...props
}) => {
  return (
    <Container
      style={{
        ...props.style,
        boxShadow: boxShadow,
        border: border,
        borderRadius: borderRadius,
      }}
      background={background}
      border={border}
      height={height}
      width={width}
      maxW={maxW}
      minW={props.minW}
      minH={props.minH}
      alignItems={props.alignItems}
      justifyContent={props.justifyContent}
      mb={props.mb}
      mr={props.mr}
      p={props.padding}
    >
      {props.children}
    </Container>
  );
};

export default ContainerCards;
